export default "/images/04 Step1Assess-Consultant-To view completed self-assessments-02.png?0cd04fbb1847a5481915812d11b9694c";